import { render, staticRenderFns } from "./SetNotification.vue?vue&type=template&id=2e957af8&scoped=true&"
import script from "./SetNotification.vue?vue&type=script&lang=js&"
export * from "./SetNotification.vue?vue&type=script&lang=js&"
import style0 from "./SetNotification.vue?vue&type=style&index=0&id=2e957af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e957af8",
  null
  
)

export default component.exports